import {
  getDocumentList,
  getGetDocumentListQueryKey,
} from '@modusign/openapi-client-external-document';
import { AxiosError } from 'axios';
import { useQuery, useQueryClient } from 'react-query';
import { PromiseType } from 'utility-types';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { getOffset } from '@app/libs/pagination';

export default function useExternalDocumentList({
  orderBy,
  query,
  limit,
  page,
  filter,
}: {
  orderBy?:
    | 'createdAt:desc'
    | 'createdAt:asc'
    | 'updatedAt:desc'
    | 'updatedAt:asc'
    | 'dateOfCompletion:desc'
    | 'dateOfCompletion:asc'
    | 'title:desc'
    | 'title:asc'
    | 'registrationNumber:desc'
    | 'registrationNumber:asc'
    | 'status:desc'
    | 'status:asc';
  query?: string;
  page: number;
  limit: number;
  filter?: {
    isRegistered?: boolean;
    labelId?: string;
    datesOfCompletion?: { from: string | null; to: string | null };
    status?: 'EFFECTIVE' | 'EXPIRED' | 'ABORTED';
    documentPeriod?: { from: string | null; to: string | null };
  };
}) {
  const workspaceId = useWorkspaceId();
  const client = useQueryClient();

  const documentsResult = useQuery<
    PromiseType<ReturnType<typeof getDocumentList>>,
    AxiosError,
    PromiseType<ReturnType<typeof getDocumentList>>
  >(
    getGetDocumentListQueryKey(workspaceId, {
      limit,
      offset: getOffset(page, limit),
      orderBy,
      q: query,
      filter,
    }),
    () =>
      getDocumentList(workspaceId, {
        offset: (page - 1) * limit,
        limit,
        orderBy,
        q: query,
        filter,
      }),
    {
      cacheTime: query?.length ? 30 : undefined,
      enabled: !!workspaceId,
    }
  );

  return {
    ...documentsResult,
    invalidateDocumentList: () => client.invalidateQueries(getGetDocumentListQueryKey(workspaceId)),
  };
}
